import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import {
  applyTheme,
  defaultThemeId,
  isThemeId,
  type ThemeId,
} from '@/lib/themes.ts'

type ThemeState = {
  /** 当前主题 ID */
  theme: ThemeId
  /** 切换主题并持久化 */
  setTheme: (theme: ThemeId) => void
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      theme: defaultThemeId,
      setTheme: (theme) => {
        applyTheme(theme)
        set({ theme })
      },
    }),
    {
      name: 'promot-theme',
      onRehydrateStorage: () => (state) => {
        applyTheme(
          state?.theme && isThemeId(state.theme) ? state.theme : defaultThemeId,
        )
      },
    },
  ),
)
